export interface PurchaseOrderLineSalesAllocationsSummaryTop {
  productKey: string;
  productDescription: string;
  quantity: number;
  allocated: number;
  currencySymbol: string;
  price: number;
  deliveryDate: Date;
}
